import { type CreateLegalEntityApiPayload } from '../api-models/LegalEntityApiModel'
import { type CreateLegalEntityInput } from '../types/CreateLegalEntityInput'

export const mapCreateLegalEntityInputToApiPayload = (
  input: CreateLegalEntityInput
): CreateLegalEntityApiPayload => {
  const payload: CreateLegalEntityApiPayload = {
    name: input.name.trim(),
    base_currency: input.baseCurrencyId,
  }

  const country = input.country?.trim()
  if (country) {
    payload.country = country
  }

  const externalId = input.externalId?.trim()
  if (externalId) {
    payload.external_id = externalId
  }

  return payload
}
